export enum ValidationVariable {
	Flow,
	Record,
	Value,
}
